@use "~theme/breakpoints";
@use "~theme/typography";

.container {
  @include breakpoints.desktop {
    margin: 65px auto 0;
    width: fit-content;
  }
}

.desktopHeading {
  display: none;

  @include breakpoints.desktop {
    @include typography.heading4;

    display: flex;
    color: var(--blue-01);
    border-bottom: 1px solid var(--blue-01);
    margin: 0 0 16px;
    justify-content: center;
  }
}

.mobileHeading {
  @include breakpoints.desktop {
    display: none;
  }
}

.cards {
  display: flex;
  flex-direction: column;
  padding: 12px 0;

  > * {
    margin: 10px 14px;
  }

  @include breakpoints.desktop {
    flex-direction: row;
    align-items: stretch;
    justify-content: center;
    padding: 0;
    margin-bottom: 40px;

    > * {
      flex: 1 1 0; // ensure all cards are the same size and grow equally
      margin: 0 28px 0 0;
      min-width: min(30vw, 360px);
    }

    > :last-child {
      margin-right: 0;
    }
  }
}

.spinner {
  margin: 0 10px 4px 0;
}

.locationImg {
  display: flex;
  justify-content: center;
  padding: 40px 0 50px;

  img {
    width: 50px;
    height: 50px;
  }
}

.noNearByOfficeContainer {
  @include breakpoints.desktop {
    margin: 52px auto 0;
    width: 400px;
  }
}

.locationText {
  text-align: center;
  display: block;
  margin: 0 16px 32px;
}

.loaderWithOfficeHeading {
  width: 386px;
  padding-bottom: 5px;
}
